import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-ice-machine-banner',
	templateUrl: './ice-machine-banner.component.html',
	styleUrls: ['./ice-machine-banner.component.scss'],
})
export class IceMachineBannerComponent implements OnInit {
	@Input() data: any = {}
	constructor(private router: Router) {}
	@Output() openModal: EventEmitter<boolean> = new EventEmitter()
  onClick(event: any) {
    event.preventDefault();
    this.openModal.emit(true);
  }
  	backgroundImage = '';

	ngOnInit(): void {
		const url = this.router.url;
		if (url.includes('maquinas-de-gelo')) {
			this.backgroundImage = '/assets/images/ice_banner.png';
		} else {
			this.backgroundImage = '/assets/images/bg-garrafa.png';
		}
	}
}
